const searchableFields = ['value', 'label', 'description', 'labelTag'];
const searchableTagFieldsStrict = ['tags'];
const searchableTagFieldsNonStrict = ['tags', 'filteringTags'];
export const matchesString = (value, searchText, strictMatching) => {
    if (!value) {
        return false;
    }
    const index = value.toLowerCase().indexOf(searchText);
    return strictMatching ? index === 0 : index > -1;
};
const matchesSingleOption = (dropdownOption, searchText, strictMatching) => {
    const option = dropdownOption.option;
    const searchStrFields = (attr) => matchesString(option[attr], searchText, strictMatching);
    const searchTagsFields = (attr) => { var _a; return (_a = option[attr]) === null || _a === void 0 ? void 0 : _a.some(value => matchesString(value, searchText, strictMatching)); };
    const searchableTagFields = strictMatching ? searchableTagFieldsStrict : searchableTagFieldsNonStrict;
    return searchableFields.some(searchStrFields) || searchableTagFields.some(searchTagsFields);
};
export const filterOptions = (options, searchText, strictMatching = false) => {
    if (searchText === '') {
        return options;
    }
    const normalizedSearchText = searchText.toLowerCase();
    let currentGroup = null;
    let parentMatched = false;
    return options.reduce((acc, option) => {
        if (option.type === 'parent') {
            parentMatched = false;
            currentGroup = option;
            if (matchesSingleOption(option, normalizedSearchText, strictMatching)) {
                parentMatched = true;
                acc.push(currentGroup);
            }
            return acc;
        }
        if (option.type !== 'child') {
            currentGroup = null;
            parentMatched = false;
        }
        if (parentMatched) {
            acc.push(option);
        }
        else if (matchesSingleOption(option, normalizedSearchText, strictMatching)) {
            if (currentGroup) {
                acc.push(currentGroup);
                currentGroup = null;
            }
            acc.push(option);
        }
        return acc;
    }, []);
};
export const isInteractive = (option) => !!option && !option.disabled && option.type !== 'parent';
export const isGroupInteractive = (option) => !!option && !option.disabled;
export const isGroup = (option) => {
    const key = 'options';
    return !!option && key in option && !!option.options;
};
//# sourceMappingURL=filter-options.js.map